import {
  parseA11yLabels,
  pluralize,
  reportMissingLabels,
} from '@/lib/a11y_labels';

// Matching is not being on screen: a match can sit in a collapsed disclosure panel,
// and a modifier class can lose to a display utility.
export function countVisible(groups, selector) {
  return groups.reduce(
    (total, group) =>
      total +
      [...group.querySelectorAll(selector)].filter(
        el => el.offsetParent !== null,
      ).length,
    0,
  );
}

export default function filterStatus(input) {
  const status = document.getElementById(input.dataset.filterStatus);
  const labels = parseA11yLabels(input.dataset, 'filter_status');

  reportMissingLabels(labels, ['count.other'], 'filter_status');

  // Without its region the filter stays silent, but throwing here would take the
  // filtering itself down with it.
  if (!status) return undefined;

  let timer;
  let announced;

  // Only the announcement waits: `polite` messages queue instead of interrupting, so
  // one per keystroke leaves a backlog to sit through. The filtering stays immediate.
  return visible => {
    const text = pluralize(labels.count, visible);

    if (text === announced) return;

    announced = text;
    clearTimeout(timer);
    timer = setTimeout(() => {
      status.textContent = text;
    }, 500);
  };
}
